import { IAvailability } from '../../../models'
import { IFindResultAvailabilities } from '../../../models/find-result-availabilities'

export enum RouteOptionStepTypeKeys {
  FETCH_ROUTE_OPTIONS = 'FETCH_ROUTE_OPTIONS',
  FETCH_ROUTE_OPTIONS_ECORRIDOR = 'FETCH_ROUTE_OPTIONS_ECORRIDOR',
  FETCH_EARLIER_ROUTE_OPTIONS = 'FETCH_EARLIER_ROUTE_OPTIONS',
  FETCH_LATER_ROUTE_OPTIONS = 'FETCH_LATER_ROUTE_OPTIONS',
  FETCHING_ROUTE_OPTIONS = 'FETCHING_ROUTE_OPTIONS',
  FETCHING_ROUTE_OPTIONS_ECORRIDOR = 'FETCHING_ROUTE_OPTIONS_ECORRIDOR',
  FETCH_ROUTE_OPTIONS_SUCCESSFUL = 'FETCH_ROUTE_OPTIONS_SUCCESSFUL',
  FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR = 'FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR',
  SET_AVAILABILITY = 'SET_AVAILABILITY',
  FETCH_RETURN_ROUTE_OPTIONS = 'FETCH_RETURN_ROUTE_OPTIONS',
  FETCHING_RETURN_ROUTE_OPTIONS = 'FETCHING_RETURN_ROUTE_OPTIONS',
  FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL = 'FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL',
  SET_RETURN_AVAILABILITY = 'SET_RETURN_AVAILABILITY'
}

export interface IFetchRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS,
  payload: { navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number }
  [extraProps: string]: unknown
}

export interface IFetchRouteOptionsEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_ECORRIDOR
  [extraProps: string]: unknown
}

export interface IFetchEearlierRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_EARLIER_ROUTE_OPTIONS
  [extraProps: string]: unknown
}

export interface IFetchLaterRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_LATER_ROUTE_OPTIONS
  [extraProps: string]: unknown
}

export interface ISetIsFetchingRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS
  [extraProps: string]: unknown
}

export interface ISetIsFetchingRouteOptionsEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS_ECORRIDOR
  [extraProps: string]: unknown
}

export interface IFetchRouteOptionsSuccessfulAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL
  payload: IFindResultAvailabilities,
  error: number
  [extraProps: string]: unknown
}

export interface IFetchRouteOptionsSuccessfulEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR
  payload: IAvailability[]
  [extraProps: string]: unknown
}

export interface ISetAvailabilityAction {
  type: typeof RouteOptionStepTypeKeys.SET_AVAILABILITY
  payload: IAvailability
  [extraProps: string]: unknown
}

export interface IFetchReturnRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS,
  payload: { navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingReturnRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_RETURN_ROUTE_OPTIONS
  [extraProps: string]: unknown
}

export interface IFetchReturnRouteOptionsSuccessfulAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL
  payload: IFindResultAvailabilities,
  error: number
  [extraProps: string]: unknown
}

export interface ISetReturnAvailabilityAction {
  type: typeof RouteOptionStepTypeKeys.SET_RETURN_AVAILABILITY
  payload?: IAvailability
  [extraProps: string]: unknown
}

export type RouteOptionStepActionTypes =
  | IFetchRouteOptionsAction
  | IFetchRouteOptionsEcorridorAction
  | IFetchEearlierRouteOptionsAction
  | IFetchLaterRouteOptionsAction
  | ISetIsFetchingRouteOptionsAction
  | ISetIsFetchingRouteOptionsEcorridorAction
  | IFetchRouteOptionsSuccessfulAction
  | IFetchRouteOptionsSuccessfulEcorridorAction
  | ISetAvailabilityAction
  | IFetchReturnRouteOptionsAction
  | ISetIsFetchingReturnRouteOptionsAction
  | IFetchReturnRouteOptionsSuccessfulAction
  | ISetReturnAvailabilityAction
